import { useGet } from "@albertine/api-client";
import { useRouteMatch } from "react-router-dom";
import type { Request } from "../../common/types/Request";
import { FirebaseId } from "../../common/validate";
import { mapApiRequestToRequest } from "../../utils/request.adapter";

type Props = {
    override?: Request;
    children: (request: Request) => React.JSX.Element;
};

function FetchRequest(props: { request: string | undefined } & Props) {
    const { request, override, children } = props;

    const { data } = useGet(
        "request",
        { param: { id: request! } },
        {
            enabled: !override && !!request && FirebaseId.safeParse(request).success,
        },
    );

    if (override) {
        return children(override);
    }

    if (!data) {
        return null;
    }
    return children(mapApiRequestToRequest(data));
}

export default FetchRequest;

export function FetchRequestFromRoute(props: { path: string | string[] } & Props) {
    const { path, override, children } = props;
    const requestId = useRouteMatch<{
        requestId: string;
    }>(path)?.params.requestId;
    return (
        <FetchRequest override={override} request={requestId}>
            {children}
        </FetchRequest>
    );
}
